import registrationInstance from '../instance'

const putDesktopUser = (id) => {
	return registrationInstance.put('/users/desktop/' + id)
}

export default putDesktopUser
